import { RiseOutlined, WarningOutlined } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation';
import { AiSparkle } from '@components/bid_request/details/StickyHeader/NsbPriceSelectors/AiSparkle';
import { SuggestedPriceDetailRow } from '@features/suggested-price-column/components/suggested-price-detail-row/suggested-price-detail-row';
import { SuggestedPriceIconTile } from '@features/suggested-price-column/components/suggested-price-icon-tile/suggested-price-icon-tile';
import { OverrideImpactInputs, OverrideImpactKey } from '@features/suggested-price-column/types/override-impact';
import { buildOverrideImpactRows } from '@features/suggested-price-column/utils/build-override-impact-rows';

const COPY_SCOPE = 'bid_request.line_items.suggested_price.explanation.impact';

/** Matches the icon size the tile gives antd glyphs, so the sparkle sits at the same weight. */
const AI_SPARKLE_SIZE = 18;

const ICON_BY_KEY: Record<OverrideImpactKey, () => JSX.Element> = {
  savings_vs_baseline: () => <RiseOutlined />,
  supplier_perception: () => <WarningOutlined />,
  vs_ai: () => <AiSparkle size={AI_SPARKLE_SIZE} tone='inherit' />,
};

/**
 * The overridden drawer's "Impact of this change" list. `buildOverrideImpactRows` decides every
 * figure and sentence variant, and omits rows it cannot compute.
 */
export const SuggestedPriceOverrideImpact = (inputs: OverrideImpactInputs) => {
  const { t } = useTranslation('common');
  const rows = buildOverrideImpactRows(inputs);

  return (
    <div data-testid='suggested-price-override-impact'>
      {rows.map(row => {
        const glyph = ICON_BY_KEY[row.key];

        return (
          <SuggestedPriceDetailRow
            key={row.key}
            dataTestId={`suggested-price-impact-${row.key}`}
            description={t(`${COPY_SCOPE}.${row.copyKey}`, row.copyParams)}
            icon={<SuggestedPriceIconTile>{glyph()}</SuggestedPriceIconTile>}
            title={t(`${COPY_SCOPE}.${row.key}`)}
          />
        );
      })}
    </div>
  );
};
